import React, { useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";
import api from "../../services/api";

const TicketFindRedirect = () => {
  const { phone } = useParams();
  const history = useHistory();

  useEffect(() => {
  const fetchTicket = async () => {
    console.log("🔎 Iniciando busca para:", phone);

    try {
      const { data } = await api.get(`/ticketfind/${phone}`);
      console.log("✅ Resposta recebida do backend:", data);

      if (data.ticketId) {
        console.log("➡️ Redirecionando para:", `/tickets/${data.ticketId}`);
        history.push(`/tickets/${data.ticketId}`);
      } else {
        alert("⚠️ Ticket não encontrado.");
      }
    } catch (error) {
      console.error("❌ Erro ao buscar ticket:", error);
      alert("Erro ao redirecionar o ticket.");
    }
  };

  fetchTicket();
}, [phone, history]);


  return <p>Redirecionando para o ticket de {phone}...</p>;
};

export default TicketFindRedirect;
